module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Clip-8ece34034b7d1e732d4fd4391335f863.svg";